import common from './datalead-common'
import resource from './datalead-resource'
import services from "../http/request";

class DataLeadBusiness {
  constructor(environment, userId) {
    if (typeof environment === 'undefined') throw new Error("Parâmetro esperado: 'environment'");
    if (typeof userId === 'undefined') throw new Error("Parâmetro esperado: 'userId'");
    console.log('DataLeadBusiness load...')

    this.environment = environment;
    this.userId = userId;
  }
   async loadDataV2(header,dataset) {
    let self = this;
    return await new Promise((resolve, reject) => {
      let billing = {
        SummaryMain: resource.Languages[common.getBrowserLang()].SummaryMain,
        UserAccountTitle: resource.Languages[common.getBrowserLang()].UserAccountTitle,
        UserCompanyTitle: resource.Languages[common.getBrowserLang()].UserCompanyTitle,
        CycleMain: resource.Languages[common.getBrowserLang()].CycleMain,
        CycleIniTitle: resource.Languages[common.getBrowserLang()].CycleIniTitle,
        CycleEndTitle: resource.Languages[common.getBrowserLang()].CycleEndTitle,
        CycleTypeTitle: resource.Languages[common.getBrowserLang()].CycleTypeTitle,
        CycleNumberTitle: resource.Languages[common.getBrowserLang()].CycleNumberTitle,
        DashIndicatorMain: resource.Languages[common.getBrowserLang()].DashIndicatorMain,
        LeadTotalBayedTitle: resource.Languages[common.getBrowserLang()].LeadTotalBayedTitle,
        TotalLeadApprovedOverflowTitle: resource.Languages[common.getBrowserLang()].TotalLeadApprovedOverflowTitle,
        LeadManagerSummarizedTitle: resource.Languages[common.getBrowserLang()].LeadManagerSummarizedTitle,
        UserAccount: this.userId,
        UserCompany: this.environment,
        UserData: [],
        BaseData: [],
        CycleIni: 0,
        CycleEnd: 0,
        CycleType: "",
        CycleNumber: 0,
        LeadTotalBayed: 0,
        LeadMyBayed: 0,
        QuoteLimit: 0,
        TotalLeadApprovedOverflow: 0,
        MyLeadApprovedOverflow: 0
      };

      //request.post(endPoint, data, config, (res) => {
        let baseData = dataset;
        const dateFrmtHeader = {year: 'numeric', month: 'numeric', day: 'numeric'};
        if (header.cMeasure === "second" || header.cMeasure === "minute" || header.cMeasure === "hour")
          Object.assign(dateFrmtHeader, {hour: 'numeric', minute: 'numeric', second: 'numeric'});
        const dateFrmtSmall = {year: 'numeric', month: 'numeric', day: 'numeric'};
        const dateFrmtFull = Object.assign(dateFrmtSmall, {hour: 'numeric', minute: 'numeric', second: 'numeric'});
        let nLeadMyBayed = 0, nLeadTotalBayed = 0, nMyLeadApprovedOverflow = 0, nTotalLeadApprovedOverflow = 0, nLastLimit = 0,
        dtLastData = new Date(header.dtStartInCycle);

baseData.map(function (item) {
  //aggregate of period
  if (header.nCycleNumber === item.nCycleNumber) {
    nLeadTotalBayed += item.nCountChunk - item.nCountCoexist;
    nTotalLeadApprovedOverflow = nLeadTotalBayed;
    billing.QuoteLimit = item.nLimit;
    if (dtLastData < new Date(item.dtAddIn)) {
      nLastLimit = Math.max(nLastLimit, item.nLimit);
    }
  }
  
  //show only if is list owner
  if (item.cUser === self.userId) {
    if (item.cTag == null)
      nLeadMyBayed += 0;
    else {
      nLeadMyBayed += item.nCountChunk - item.nCountCoexist;
    }
    nMyLeadApprovedOverflow = nLeadMyBayed;
    billing.UserData.push(item);
  }

  //reformat itens
  let newProps = {
    cStatusDesc: resource.Languages[common.getBrowserLang()].OperationStatus[item.cStatus],
    type: item.cTag ? '💵' : '',
   dtAddInFrmt: new Date(item.dtAddIn).toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo', // Adicionando o fuso horário -3
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', ''),
    dtEndFrmt: new Date(item.dtEnd).toLocaleDateString(common.getBrowserLang(), dateFrmtSmall),
    dtConfirmFrmt: item.dtConfirm == null ? null : new Date(item.dtConfirm).toLocaleDateString(common.getBrowserLang(), dateFrmtFull),
    nNewOnes: item.cTag ? item.nCountChunk - item.nCountCoexist : 'Gratuíto'
  };
  
  return Object.assign(item, newProps);
});

        billing.BaseData = baseData;
        billing.CycleIni = new Date(header.dtStartInCycle).toLocaleDateString(common.getBrowserLang(), dateFrmtHeader);
        billing.CycleEnd = new Date(header.dtFinishInCycle).toLocaleDateString(common.getBrowserLang(), dateFrmtHeader);
        billing.CycleType = resource.Languages[common.getBrowserLang()].PeriodMeasure[header.cMeasure];
        billing.CycleNumber = header.nCycleNumber || -1;
        billing.LeadTotalBayed = nLeadTotalBayed;
        billing.LeadMyBayed = nLeadMyBayed;
        billing.TotalLeadApprovedOverflow = nTotalLeadApprovedOverflow < nLastLimit ? nLastLimit - nTotalLeadApprovedOverflow : nTotalLeadApprovedOverflow - nLastLimit;
        billing.MyLeadApprovedOverflow = nMyLeadApprovedOverflow;
        billing.leadMyExceeded = nMyLeadApprovedOverflow;
        billing.leadCompanyAccumulated = billing.LeadTotalBayed >= billing.LeadMyBayed ?
        billing.LeadTotalBayed - billing.LeadMyBayed :
        billing.LeadMyBayed - billing.LeadTotalBayed;

        //Exibindo apenas listas com compra confirmada pelo usuário
        //https://cognatis.atlassian.net/browse/RBF-13
        // let filterData = clkData.filter(function (row) {
        //    //return (row["bConfirm"] === true) && (row["bSnapshot"] === true);
        //   return (row["bConfirm"] === true);
      // });
      console.log('Billing Data');
      console.log(billing);
        resolve(billing);
     
        //reject({message: resource.Languages[common.getBrowserLang()].Sorry, type: "error", stack: error});

    }, (error) => {
      reject(error)
    })
  }

  async loadData(header) {
    let self = this;
    return await new Promise((resolve, reject) => {
      if (typeof header === 'undefined') reject("Parâmetro esperado: 'header'");
      if (!header.hasOwnProperty("nId")) reject("'nId' deve ser um número inteiro");
      if (!header.hasOwnProperty("cClientTag")) reject("'cClientTag' deve ser um número inteiro");

      let command = common.nano(resource.Queries["Lead"].DataSet, {0: header.nId});
      let data = {"ccommand": command};
      let request = new services({tag: 'das'});
      let endPoint = '/api/0.1-a/ProxyPostgRest/api/rpc/command';
      let config = {headers: {'Content-Type': 'application/json'}};
      let billing = {
        SummaryMain: resource.Languages[common.getBrowserLang()].SummaryMain,
        UserAccountTitle: resource.Languages[common.getBrowserLang()].UserAccountTitle,
        UserCompanyTitle: resource.Languages[common.getBrowserLang()].UserCompanyTitle,
        CycleMain: resource.Languages[common.getBrowserLang()].CycleMain,
        CycleIniTitle: resource.Languages[common.getBrowserLang()].CycleIniTitle,
        CycleEndTitle: resource.Languages[common.getBrowserLang()].CycleEndTitle,
        CycleTypeTitle: resource.Languages[common.getBrowserLang()].CycleTypeTitle,
        CycleNumberTitle: resource.Languages[common.getBrowserLang()].CycleNumberTitle,
        DashIndicatorMain: resource.Languages[common.getBrowserLang()].DashIndicatorMain,
        LeadTotalBayedTitle: resource.Languages[common.getBrowserLang()].LeadTotalBayedTitle,
        TotalLeadApprovedOverflowTitle: resource.Languages[common.getBrowserLang()].TotalLeadApprovedOverflowTitle,
        LeadManagerSummarizedTitle: resource.Languages[common.getBrowserLang()].LeadManagerSummarizedTitle,
        UserAccount: this.userId,
        UserCompany: this.environment,
        UserData: [],
        BaseData: [],
        CycleIni: 0,
        CycleEnd: 0,
        CycleType: "",
        CycleNumber: 0,
        LeadTotalBayed: 0,
        LeadMyBayed: 0,
        QuoteLimit: 0,
        TotalLeadApprovedOverflow: 0,
        MyLeadApprovedOverflow: 0
      };

      request.post(endPoint, data, config, (res) => {
        if (res.status !== 200) {
          reject(res.data.message || res.statusText);
        }
        if (res.data === "" || res.data === null  || res.data === undefined ) {
          reject('Não há dados disponíveis nesta conta')
        }
        let baseData = res.data;
        const dateFrmtHeader = {year: 'numeric', month: 'numeric', day: 'numeric'};
        if (header.cMeasure === "second" || header.cMeasure === "minute" || header.cMeasure === "hour")
          Object.assign(dateFrmtHeader, {hour: 'numeric', minute: 'numeric', second: 'numeric'});
        const dateFrmtSmall = {year: 'numeric', month: 'numeric', day: 'numeric'};
        const dateFrmtFull = Object.assign(dateFrmtSmall, {hour: 'numeric', minute: 'numeric', second: 'numeric'});
        let nLeadMyBayed = 0, nLeadTotalBayed = 0, nMyLeadApprovedOverflow = 0, nTotalLeadApprovedOverflow = 0, nLastLimit = 0,
          dtLastData = new Date(header.dtStartInCycle);

        baseData.map(function (item) {
          //aggregate of period
          if (header.nCycleNumber === item.nCycleNumber) {
            nLeadTotalBayed += item.nCountChunk - item.nCountCoexist;
            nTotalLeadApprovedOverflow = nLeadTotalBayed;
            billing.QuoteLimit = item.nLimit;
            if (dtLastData < new Date(item.dtAddIn)) {
              nLastLimit = nLastLimit < item.nLimit ? item.nLimit : nLastLimit;
            }
          }
          //show only if is list owner
          if (item.cUser === self.userId) {
            nLeadMyBayed += item.nCountChunk - item.nCountCoexist;
            nMyLeadApprovedOverflow = nLeadMyBayed;
            billing.UserData.push(item);
          }

          //reformat itens
          let newProps = {
            cStatusDesc: resource.Languages[common.getBrowserLang()].OperationStatus[item.cStatus],
            dtInitFrmt: new Date(item.dtInit).toLocaleDateString(common.getBrowserLang(), dateFrmtSmall),
            dtEndFrmt: new Date(item.dtEnd).toLocaleDateString(common.getBrowserLang(), dateFrmtSmall),
            dtAddInFrmt: new Date(item.dtAddIn).toLocaleDateString(common.getBrowserLang(), dateFrmtFull),
            dtConfirmFrmt: item.dtConfirm == null ? null : new Date(item.dtConfirm).toLocaleDateString(common.getBrowserLang(), dateFrmtFull),
            nNewOnes: item.nCountChunk - item.nCountCoexist
          };
          return Object.assign(item, newProps);
        });

        billing.BaseData = baseData;
        billing.CycleIni = new Date(header.dtStartInCycle).toLocaleDateString(common.getBrowserLang(), dateFrmtHeader);
        billing.CycleEnd = new Date(header.dtFinishInCycle).toLocaleDateString(common.getBrowserLang(), dateFrmtHeader);
        billing.CycleType = resource.Languages[common.getBrowserLang()].PeriodMeasure[header.cMeasure];
        billing.CycleNumber = header.nCycleNumber || -1;
        billing.LeadTotalBayed = nLeadTotalBayed;
        billing.LeadMyBayed = nLeadMyBayed;
        billing.TotalLeadApprovedOverflow = nTotalLeadApprovedOverflow < nLastLimit ? nLastLimit - nTotalLeadApprovedOverflow : nTotalLeadApprovedOverflow - nLastLimit;
        billing.MyLeadApprovedOverflow = nMyLeadApprovedOverflow;
        billing.leadMyExceeded = nMyLeadApprovedOverflow;
        billing.leadCompanyAccumulated = billing.LeadTotalBayed >= billing.LeadMyBayed ?
            billing.LeadTotalBayed - billing.LeadMyBayed :
            billing.LeadMyBayed - billing.LeadTotalBayed;

        //Exibindo apenas listas com compra confirmada pelo usuário
        //https://cognatis.atlassian.net/browse/RBF-13
        // let filterData = clkData.filter(function (row) {
        //    //return (row["bConfirm"] === true) && (row["bSnapshot"] === true);
        //   return (row["bConfirm"] === true);
        // });
        resolve(billing);
      }, (error) => {
        reject({message: resource.Languages[common.getBrowserLang()].Sorry, type: "error", stack: error});
      });
    }, (error) => {
      reject(error)
    })
  }

  async loadLead() {
    return await new Promise((resolve, reject) => {
      let command = common.nano(resource.Queries["Lead"].DataHeader, {0: this.environment});
      let data = {"ccommand": command};
      let request = new services({tag: 'das'});
      let endPoint = '/api/0.1-a/ProxyPostgRest/api/rpc/command';
      let config = {
        headers: {
          'Content-Type': 'application/json',
        }
      };
      request.post(endPoint, data, config, response => resolve(response), () => reject)
    }, (error) => {
      console.log(error)
    })
  }
}

export  { DataLeadBusiness }
